










import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class AlertSection extends Vue {
  @Prop({ required: true })
  readonly title: string

  @Prop({ required: true })
  readonly messages: string[]
}
